import axios from '../../localAxios';
import { WorkspaceRole } from '../getWorkspaceMembers';
import { workspaceCodeURL } from '../workspacesURLs';

interface WorkspaceCode {
  code: string;
  workspaceRole: WorkspaceRole;
}

export async function disableWorkspaceCode({ workspaceId, workspaceRole }) {
  const url = workspaceCodeURL({
    workspaceId: workspaceId,
    workspaceRole: workspaceRole,
  });
  const result = await axios.put<WorkspaceCode>(url.href, {
    regenerate: false,
    role: workspaceRole,
  });
  return result.data;
}
